// Tracciamento RINOVA (PARTI 2-4): sessione anonima, attribuzione primo/ultimo
// contatto, rilevamento traffico interno e contatore funnel leggero.
// Nessun dato personale. Nessun nuovo cookie: solo localStorage anonimo.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const API = `${BACKEND_URL}/api`;

const SID_KEY = "rinova_sid";
const FIRST_KEY = "rinova_attr_first";
const LAST_KEY = "rinova_attr_last";
const INTERNAL_FLAG = "rinova_internal";
const ADMIN_TOKEN_KEY = "rinova_admin_token";
const PUBLIC_HOSTS = ["rinovotech.it", "www.rinovotech.it"];

function ls(k) { try { return localStorage.getItem(k); } catch { return null; } }
function lsSet(k, v) { try { localStorage.setItem(k, v); } catch { /* noop */ } }
function lsDel(k) { try { localStorage.removeItem(k); } catch { /* noop */ } }

function readCookie(name) {
  const m = document.cookie.match(new RegExp("(?:^|;\\s*)" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[1]) : null;
}

export function getSessionId() {
  let sid = ls(SID_KEY);
  if (!sid) {
    sid = (window.crypto && window.crypto.randomUUID)
      ? window.crypto.randomUUID()
      : String(Date.now()) + "-" + Math.random().toString(36).slice(2, 10);
    lsSet(SID_KEY, sid);
  }
  return sid;
}

// ?interno=1 imposta un flag persistente; ?interno=0 lo rimuove.
function syncInternalFlag() {
  try {
    const q = new URLSearchParams(window.location.search);
    const v = q.get("interno");
    if (v === "1") lsSet(INTERNAL_FLAG, "1");
    else if (v === "0") lsDel(INTERNAL_FLAG);
  } catch { /* noop */ }
}

// Una sessione è interna se: (a) c'è un login admin nel browser, (b) flag
// ?interno=1 persistente, (c) il dominio non è quello pubblico (anteprima,
// localhost, ecc.). In caso di dubbio consideriamo interna (non sporca i dati).
export function isInternalSession() {
  try {
    syncInternalFlag();
    if (ls(ADMIN_TOKEN_KEY)) return true;
    if (ls(INTERNAL_FLAG) === "1") return true;
    const host = (window.location.hostname || "").toLowerCase();
    if (!PUBLIC_HOSTS.includes(host)) return true;
    return false;
  } catch {
    return true;
  }
}

function currentAttribution() {
  const q = new URLSearchParams(window.location.search);
  const get = (k) => { const v = q.get(k); return v ? String(v).slice(0, 120) : null; };
  let refDomain = null;
  try {
    if (document.referrer) refDomain = new URL(document.referrer).hostname.replace(/^www\./, "");
  } catch { /* noop */ }
  return {
    utm_source: get("utm_source"),
    utm_medium: get("utm_medium"),
    utm_campaign: get("utm_campaign"),
    utm_content: get("utm_content"),
    utm_term: get("utm_term"),
    fbclid_present: !!q.get("fbclid"),
    landing_page: (window.location.pathname || "/").slice(0, 300),
    referrer_domain: refDomain,
    ts: new Date().toISOString(),
  };
}

function hasSignal(a) {
  return !!(a.utm_source || a.utm_campaign || a.fbclid_present || a.referrer_domain);
}

// Cattura attribuzione: PRIMO contatto (una volta) + ULTIMO contatto
// (aggiornato quando c'è un segnale, es. utm o referrer).
export function captureAttribution() {
  try {
    const a = currentAttribution();
    if (!ls(FIRST_KEY)) lsSet(FIRST_KEY, JSON.stringify(a));
    if (hasSignal(a) || !ls(LAST_KEY)) lsSet(LAST_KEY, JSON.stringify(a));
  } catch { /* noop */ }
}

function readJSON(k) { try { return JSON.parse(ls(k) || "null"); } catch { return null; } }

export function getAttribution() {
  return { primo: readJSON(FIRST_KEY), ultimo: readJSON(LAST_KEY) };
}

// Oggetto `tracking` da allegare all'ordine (primo/ultimo + session_id + compat).
export function getOrderTracking() {
  const { primo, ultimo } = getAttribution();
  const t = { session_id: getSessionId() };
  if (primo) t.primo = primo;
  if (ultimo) t.ultimo = ultimo;
  const q = new URLSearchParams(window.location.search);
  ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"].forEach((k) => {
    const v = q.get(k); if (v) t[k] = v;
  });
  const fbp = readCookie("_fbp"); if (fbp) t.fbp = fbp;
  const fbc = readCookie("_fbc"); if (fbc) t.fbc = fbc;
  return t;
}

// Contatore funnel (PARTE 4): stesso punto del Pixel, escluse le sessioni interne.
export function funnelTick(evento) {
  try {
    if (isInternalSession()) return;
    const { ultimo } = getAttribution();
    axios.post(`${API}/t`, {
      evento,
      session_id: getSessionId(),
      utm_source: (ultimo && ultimo.utm_source) || null,
    }).catch(() => {});
  } catch { /* noop */ }
}
